import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';

import Icon from './Icon';
import Small from './Small';

import './SocialMediaLink.scss';

const SocialMediaLink = (link) => {
  const href = _.get(link, ['link', 'href'], '');
  const icon = _.get(link, ['link', 'icon'], '');
  const title = _.get(link, ['link', 'title'], null);

  return (
    <a
      itemProp="sameAs"
      href={href}
      className="sm-link"
      rel="noopener noreferrer me"
      target="_blank"
      data-selector-type="SocialMediaLink"
      data-selector-title={title}
    >
      <div className="circle-wrapper">
        <Icon
          name={icon}
          dark
        />
      </div>
      {title && (
        <span className="sm-link__label">
          <Small>
            <strong>{title}</strong>
          </Small>
        </span>
      )}
    </a>
  );
};

SocialMediaLink.defaultProps = {
  link: {},
};

SocialMediaLink.propTypes = {
  link: PropTypes.shape({}),
};

export default SocialMediaLink;
